import { PermissionTranslationKeys } from './translationKeys';
import { Permission } from './types';

export class BasePermissionManager {
  noPermissionInOffline(): Permission {
    return this.forbid(PermissionTranslationKeys.OFFLINE_UNAVAILABLE);
  }

  allow(): Permission {
    return this.createPermission(true);
  }

  forbid(message: string): Permission {
    return this.createPermission(false, message);
  }

  createPermission(permission: boolean, reason?: string): Permission {
    return { permission, reason };
  }
}

const basePermissionManagerInstance = new BasePermissionManager();
export const forbid = basePermissionManagerInstance.forbid.bind(
  basePermissionManagerInstance
);
export const allow = basePermissionManagerInstance.allow.bind(
  basePermissionManagerInstance
);
export const createPermission =
  basePermissionManagerInstance.createPermission.bind(
    basePermissionManagerInstance
  );
